import React from 'react';

const Background = ({ backgroundImage }) => {
  const backgroundStyle = backgroundImage 
    ? {
        backgroundImage: `url("${backgroundImage}")`,
        filter: 'brightness(0.8) contrast(1.1)',
      }
    : {
        backgroundColor: '#000000',
      };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 0,
        ...backgroundStyle,
      }}
    />
  );
};

export default Background;
